module.exports = __webpack_public_path__ + "img/q9.7ff88cc9.png";